
window.$ = window.jQuery = require('jquery');
require('jquery-ui/ui/widgets/autocomplete');
require('jquery-ui/ui/widgets/datepicker');
require('jquery-ui/ui/i18n/datepicker-hr');

require('jquery.easing');
//require('jquery-collapse/src/jquery.collapse');

require('block-ui');

require('./bootstrap');
require('bootstrap');


require('datatables.net-bs4');


require('admin-lte/build/js/AdminLTE');

//require('startbootstrap-sb-admin-2/vendor/fontawesome-free/js/all.min');

require('datatables.net-bs4');


// window.Dropzone = require('dropzone');
import Dropzone from "dropzone";
Dropzone.autoDiscover = false;

require('admin-lte/plugins/chart.js/Chart.min');


require('./common');

